module.exports = __webpack_public_path__ + "media/images/phi3-fdecc5e49566351823d059f70897a163.jpg";